var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{ref:"form",attrs:{"action":_vm.url,"method":"POST","target":"_blank"}},[_vm._l((_vm.params),function(value,key){return _c('input',{key:key,attrs:{"name":key,"hidden":""},domProps:{"value":value}})}),_c('Button',{on:{"click":_vm.submit}},[_vm._v(" Оплатить ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }